import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

// ✅ Format a date like "May 21, 2025"
export function formatDateToShortString(dateInput) {
    const date = new Date(dateInput);
    if (isNaN(date)) return "Invalid date";

    const options = { month: 'long', day: 'numeric', year: 'numeric' };
    return date.toLocaleDateString('en-US', options);
}

export function formatDateToTodayTime(input) {
    const dateUTC = new Date(input);
    const dateIST = new Date(dateUTC.getTime() + 5.5 * 60 * 60 * 1000); // add 5.5 hours

    const optionsDate = {
        day: "2-digit",
        month: "short",
        year: "numeric",
    };

    const optionsTime = {
        hour: "numeric",
        minute: "numeric",
        hour12: true,
    };

    const datePart = dateIST.toLocaleDateString("en-US", optionsDate);
    const timePart = dateIST.toLocaleTimeString("en-US", optionsTime);

    return `${datePart} at ${timePart}`;
}

// export function formatSupport(support) {
//     let percentage = support * 100;
//     let fixed = percentage.toFixed(2);
  
//     if (parseFloat(fixed) > 0) {
//       return fixed;
//     }
  
//     // Try more decimal places until non-zero or fallback
//     for (let i = 3; i <= 8; i++) {
//       fixed = percentage.toFixed(i);
//       if (parseFloat(fixed) > 0) {
//         return fixed;
//       }
//     }
  
//     return "< 0.000001"; // fallback if still 0
//   }

export function formatSupport(support) {
  let percentage = support * 100;

  for (let i = 2; i <= 8; i++) {
    let fixed = percentage.toFixed(i);
    if (parseFloat(fixed) > 0) {

      return Number(fixed);
    }
  }

  return "< 0.000001";
}

  export function formatConfidence(support) {
    let percentage = support * 100;
    let fixed = percentage.toFixed(2);
  
    if (parseFloat(fixed) > 0) {
      return fixed;
    }
  
    // Try more decimal places until non-zero or fallback
    for (let i = 3; i <= 8; i++) {
      fixed = percentage.toFixed(i);
      if (parseFloat(fixed) > 0) {
        return fixed;
      }
    }
  
    return "< 0.000001"; // fallback if still 0
  }

  export function formatDecimalPercentage(support) {
    let percentage = support * 100;
    let fixed = percentage.toFixed(2);
  
    if (parseFloat(fixed) > 0) {
      return fixed;
    }
  
    // Try more decimal places until non-zero or fallback
    for (let i = 3; i <= 8; i++) {
      fixed = percentage.toFixed(i);
      if (parseFloat(fixed) > 0) {
        return fixed;
      }
    }
  
    return "< 0.000001"; // fallback if still 0
  }

  export function formatLift(support) {
    let percentage = support;
    if(percentage){
      let fixed = percentage?.toFixed(2);
  
      if (parseFloat(fixed) > 0) {
        return fixed;
      }
    
      // Try more decimal places until non-zero or fallback
      for (let i = 3; i <= 8; i++) {
        fixed = percentage?.toFixed(i);
        if (parseFloat(fixed) > 0) {
          return fixed;
        }
      }
      return "0"; // fallback if still 0
    }
    return "0"
  
    
  }

  export const getCategoryNames = (orderCategory,symbol=",") => {
    if (!Array.isArray(orderCategory) || orderCategory.length === 0) return "N/A";
  
    return orderCategory.map(cat => cat.cateName || "Unknown").join(` ${symbol} `);
  };
  export function truncateDescription(text, wordLimit = 8) {
    if (!text || typeof text !== 'string') return '';
    const words = text.trim().split(/\s+/);
    if (words.length <= wordLimit) return text;
    return words.slice(0, wordLimit).join(' ') + '...';
  }


  export const getColorFromSegment = (segment) => {
    switch (segment.toLowerCase()) {
      case 'champion':
        return 'green';
      case 'loyalist':
        return 'blue';
      case 'potential':
        return 'orange';
      case 'new':
        return 'purple';
      case 'at risk':
        return 'red';
      case 'hibernating':
        return 'pink';
      default:
        return 'gray';
    }
  };



  export function getStrength(rule,type) {
    const MIN_SUPPORT_PCT = 0.01;      // e.g., 0.01%
    const MIN_CONFIDENCE_PCT = 50.0;   // e.g., 50%
    const supportPct = rule.support * 100;
    const confidencePct = rule.confidence * 100;
    const lift = rule.lift;
  
    const isFrequent   = supportPct    >= MIN_SUPPORT_PCT;
    const isReliable   = confidencePct >= MIN_CONFIDENCE_PCT;
    const isPositive   = lift           > 1.0;
  
    if (isFrequent && isReliable && isPositive) {
      return 'Strong';
    }
    return 'Weak/Moderate';
  }



  export function getBundleTags(support, confidence, lift ) {
    const tags = [];
    const supportPct = support * 100;
    const confidencePct = confidence * 100;
  
    // Tag by Support
    if (supportPct >= 2.0) {
      tags.push('Best Seller');
    } else if (supportPct >= 1.0) {
      tags.push('Popular Bundle');
    } else {
      tags.push('Niche Pick');
    }
  
    // Tag by Confidence
    if (confidencePct >= 80.0) {
      tags.push('Top Recommendation');
    } else if (confidencePct >= 50.0) {
      tags.push('Highly Recommended');
    } else {
      tags.push('Try It Out');
    }

    // Tag by Lift
    if (lift >= 10.0) {
      tags.push('Hot Pick');
    } else if (lift >= 3.0) {
      tags.push('Insightful Combo');
    } else if (lift > 1.0) {
      tags.push('Related Items');
    }
  
    return tags;
  }


  export function getStrengthColor(rule) {
    const MIN_SUPPORT_PCT = 0.01;      // e.g., 0.01%
    const MIN_CONFIDENCE_PCT = 50.0;   // e.g., 50%
    const supportPct = rule.support * 100;
    const confidencePct = rule.confidence * 100;
    const lift = rule.lift;
  
    const isFrequent   = supportPct    >= MIN_SUPPORT_PCT;
    const isReliable   = confidencePct >= MIN_CONFIDENCE_PCT;
    const isPositive   = lift           > 1.0;
  
    if (isFrequent && isReliable && isPositive) {
      return 'bg-green-100 text-green-700';
    }
    return 'bg-red-100 text-red-700';
  }


  export function getStrengthThumb(rule) {
    const MIN_SUPPORT_PCT = 0.01;      // e.g., 0.01%
    const MIN_CONFIDENCE_PCT = 50.0;   // e.g., 50%
    const supportPct = rule.support * 100;
    const confidencePct = rule.confidence * 100;
    const lift = rule.lift;
  
    const isFrequent   = supportPct    >= MIN_SUPPORT_PCT;
    const isReliable   = confidencePct >= MIN_CONFIDENCE_PCT;
    const isPositive   = lift           > 1.0;
  
    if (isFrequent && isReliable && isPositive) {
      return 'fas fa-thumbs-up mr-1';
    }
    return 'fas fa-thumbs-down mr-1';
  }


  function detectUseCase(categories = []) {
    const lowerCategories = categories.map(cat => cat.toLowerCase());
  
    if (lowerCategories.includes("recycling")) {
      return "for sorted recycling and eco-friendly disposal";
    } else if (lowerCategories.includes("home")) {
      return "perfect for everyday home cleanup";
    } else if (lowerCategories.includes("business")) {
      return "ideal for office or commercial spaces";
    } else if (lowerCategories.includes("wheeled rollout cart")) {
      return "designed to fit large outdoor bins and carts";
    } else if (lowerCategories.includes("low density")) {
      return "strong enough for heavy-duty loads";
    } else if (lowerCategories.includes("trash bags for miami")) {
      return "tailored for regional pickup needs";
    } else {
      return "";
    }
  }
  
export function generateRecommendationMessagesFromAssociationOld(data) {
  const antecedent = data?.antecedents?.[0];
  const consequent = data?.consequent?.[0];

  const antecedentTitle = antecedent?.product_title || "this item";
  const consequentTitle = consequent?.product_title || "another item";
  const confidence = data?.confidence || 0;
  const lift = data?.lift || 0;
  const supportCount = data?.totalPurchasedTogether || 0;
  const tags = consequent?.category?.map(cat => cat.cateName.toLowerCase()) || [];

  const confidencePct = Math.round(confidence * 100);


  // Build trust phrase
  let trustPhrase = "";
  if (confidencePct >= 99) {
    trustPhrase = `100% of customers who purchased '${antecedentTitle}' also bought '${consequentTitle}'.`;
  } else if (confidencePct >= 90) {
    trustPhrase = `${confidencePct}% of customers who bought '${antecedentTitle}' also purchased '${consequentTitle}'.`;
  } else if (confidencePct >= 70) {
    trustPhrase = `Most customers chose '${consequentTitle}' along with '${antecedentTitle}'.`;
  } else {
    trustPhrase = `Many customers who viewed '${antecedentTitle}' also considered '${consequentTitle}'.`;
  }


   // Message object
   const messages = {
    "🛒 Bought Together": trustPhrase,
    "✨ You May Also Like": `Looking for something that pairs well with '${antecedentTitle}'? Try this popular companion item.`,
    "🔥 Most Popular": `This item is among the most frequently purchased add-ons by customers exploring similar products.`,
    "🧠 Recently Viewed": `You recently explored '${antecedentTitle}'. Customers who viewed this often go on to consider '${consequentTitle}'.`,
    "📦 Complete the Set / Bundle": `Want to make the most of your selection? Add '${consequentTitle}' to complete a popular product combination.`,
    "⚡ Upsell (Premium Alternative)": `Looking for more flexibility or usage options? Consider adding '${consequentTitle}' to enhance your experience.`,
    "💡 Cross-sell (Complementary Item)": `Customers who purchased '${antecedentTitle}' often included '${consequentTitle}' to improve convenience.`,
    "🧩 Frequently Viewed Together": `These two products are often browsed together — '${antecedentTitle}' and '${consequentTitle}' make a smart combo.`,
    "📈 Confidence & Lift": `Confidence: ${confidencePct}%, Lift: ${lift.toFixed(2)}x, Bought Together: ${supportCount} times.`
  };
  
  const html = `
  <div class="space-y-4 bg-white border border-gray-200 rounded-xl p-6 shadow-sm text-sm text-gray-800">
    
    <div class="flex gap-3 items-start">
      <div class="text-xl">🛒</div>
      <p><strong>Bought Together:</strong> Most customers chose 'Rubber Band for 95-96 Gallon Trash Can - main' along with '95-96 Gallon Trash Bags on Rolls - 1.2 Mil - 15/Case - main'.</p>
    </div>

    <div class="flex gap-3 items-start">
      <div class="text-xl">✨</div>
      <p><strong>You May Also Like:</strong> Looking for something that pairs well with '95-96 Gallon Trash Bags on Rolls - 1.2 Mil - 15/Case - main'? Try this popular companion item.</p>
    </div>

    <div class="flex gap-3 items-start">
      <div class="text-xl">🔥</div>
      <p><strong>Most Popular:</strong> This item is among the most frequently purchased add-ons by customers exploring similar products.</p>
    </div>

    <div class="flex gap-3 items-start">
      <div class="text-xl">🧠</div>
      <p><strong>Recently Viewed:</strong> You recently explored '95-96 Gallon Trash Bags on Rolls - 1.2 Mil - 15/Case - main'. Customers who viewed this often go on to consider 'Rubber Band for 95-96 Gallon Trash Can - main'.</p>
    </div>

    <div class="flex gap-3 items-start">
      <div class="text-xl">📦</div>
      <p><strong>Complete the Set / Bundle:</strong> Want to make the most of your selection? Add 'Rubber Band for 95-96 Gallon Trash Can - main' to complete a popular product combination.</p>
    </div>

    <div class="flex gap-3 items-start">
      <div class="text-xl">⚡</div>
      <p><strong>Upsell (Premium Alternative):</strong> Looking for more flexibility or usage options? Consider adding 'Rubber Band for 95-96 Gallon Trash Can - main' to enhance your experience.</p>
    </div>

    <div class="flex gap-3 items-start">
      <div class="text-xl">💡</div>
      <p><strong>Cross-sell (Complementary Item):</strong> Customers who purchased '95-96 Gallon Trash Bags on Rolls - 1.2 Mil - 15/Case - main' often included 'Rubber Band for 95-96 Gallon Trash Can - main' to improve convenience.</p>
    </div>

    <div class="flex gap-3 items-start">
      <div class="text-xl">🧩</div>
      <p><strong>Frequently Viewed Together:</strong> These two products are often browsed together — '95-96 Gallon Trash Bags on Rolls - 1.2 Mil - 15/Case - main' and 'Rubber Band for 95-96 Gallon Trash Can - main' make a smart combo.</p>
    </div>

    <div class="flex gap-3 items-start">
      <div class="text-xl">📈</div>
      <p><strong>Confidence & Lift:</strong> Confidence: 80%, Lift: 8.05x, Bought Together: 937 times.</p>
    </div>

  </div>
`;

  return html;

}



export function generateRecommendationMessagesFromAssociation(data) {
  const antecedent = data?.antecedents?.[0];
  const consequent = data?.consequent?.[0];

  let allConsequentTitle = []
  let allAntecedentTitle = []

  let allConsequent = data?.consequent;
  let allAntecedent = data?.antecedents;
  allConsequent.map((title)=>{
    allConsequentTitle.push(title.product_title)
  })

  allAntecedent.map((title)=>{
    allAntecedentTitle.push(title.product_title)
  })

  const antecedentTitle = antecedent?.product_title || "this item";
  const consequentTitle = consequent?.product_title || "another item";
  const confidence = data?.confidence || 0;
  const lift = data?.lift || 0;
  const supportCount = data?.totalPurchasedTogether || 0;

  const confidencePct = Math.round(confidence * 100);

  // Trust-based phrasing
  let trustPhrase = "";
  if (confidencePct >= 99) {
    trustPhrase = `100% of customers who purchased '${allAntecedentTitle.join(", ")}' also bought '${allConsequentTitle.join(", ")}'.`;
  } else if (confidencePct >= 90) {
    trustPhrase = `${confidencePct}% of customers who bought '${allAntecedentTitle.join(", ")}' also purchased '${allConsequentTitle.join(", ")}'.`;
  } else if (confidencePct >= 70) {
    trustPhrase = `Most customers chose '${allConsequentTitle.join(", ")}' along with '${allAntecedentTitle.join(", ")}'.`;
  } else {
    trustPhrase = `Many customers who viewed '${allAntecedentTitle.join(", ")}' also considered '${allConsequentTitle.join(", ")}'.`;
  }

  // console.log(allConsequent,"allConsequent")


  let forBox = [
    {
      icon: "🛒", // Cart
      label: "Bought Together",
      message: `Customers who bought these items often add: ${allConsequentTitle.join(",")}`,
    },
    {
      icon: "✨", // Sparkle
      label: "You May Also Like",
      message: `Customers exploring these items often try: ${allConsequentTitle.join(",")}`,
    },
    {
      icon: "📦", // Package
      label: "Complete the Set",
      message: `Make a perfect breakfast combo with: ${allConsequentTitle.join(",")}`,
    },
    {
      icon: "💡", // Light bulb
      label: "Cross-sell (Complementary Item)",
      message: `Enhance your setup with: ${allConsequentTitle.join(",")}`,
    },
    {
      icon: "⚡", // High voltage
      label: "Upsell Opportunity",
      message: `Consider this premium alternative: ${allConsequentTitle.join(",")}`,
    },
    {
      icon: "🧩", // Puzzle piece
      label: "Bundle Suggestion",
      message: `Frequently purchased as a bundle: ${allConsequentTitle.join(",")}`,
    },
    {
      icon: "🔥", // Fire
      label: "Most Popular",
      message: `${allConsequentTitle.join(",")} is one of the most popular add-ons`,
    },
  ];



  const forAdditions =  [
    {
      icon: "🛒",
      label: "Bought Together",
      message: trustPhrase,
    },
    {
      icon: "✨",
      label: "You May Also Like",
      message: `Looking for something that pairs well with '${allAntecedentTitle.join(", ")}'? Try this popular companion item.`,
    },
    {
      icon: "🔥",
      label: "Most Popular",
      message: `This item is among the most frequently purchased add-ons by customers exploring similar products.`,
    },
    {
      icon: "🧠",
      label: "Recently Viewed",
      message: `You recently explored '${allAntecedentTitle.join(", ")}'. Customers who viewed this often go on to consider '${allConsequentTitle.join(", ")}'.`,
    },
    {
      icon: "📦",
      label: "Complete the Set / Bundle",
      message: `Want to make the most of your selection? Add '${allConsequentTitle.join(", ")}' to complete a popular product combination.`,
    },
    {
      icon: "⚡",
      label: "Upsell (Premium Alternative)",
      message: `Looking for more flexibility or usage options? Consider adding '${allConsequentTitle.join(", ")}' to enhance your experience.`,
    },
    {
      icon: "💡",
      label: "Cross-sell (Complementary Item)",
      message: `Customers who purchased '${allAntecedentTitle.join(", ")}' often included '${allConsequentTitle.join(", ")}' to improve convenience.`,
    },
    {
      icon: "🧩",
      label: "Frequently Viewed Together",
      message: `These two products are often browsed together — '${allAntecedentTitle.join(", ")}' and '${allConsequentTitle.join(", ")}' make a smart combo.`,
    },
    {
      icon: "📈",
      label: "Confidence & Lift",
      message: `Confidence: ${confidencePct}%, Lift: ${lift.toFixed(2)}x, Bought Together: ${supportCount} times.`,
    },
  ];

  return {
    forBox,
    forAdditions
  }
}